import React from "react";
import { withPrefix } from "gatsby";

import Layout from "../components/Layout";
import Sidebar from "../components/Sidebar";
import config from "../../config";

import avatar from '../assets/images/avatar4.jpg';
import camp from "../assets/images/rohingyacamp.jpg";
import srcEffect from "../assets/images/FBPost-media.png";
import violation from "../assets/images/violation.png";

const Named =({ data }) => (
  <Layout>
    <Sidebar />
    <div className="container-fluid p-0">
      <section
        className="resume-section p-lg-5 p-md-4 d-flex align-items-center"
        id="about"
      >
        <div className="w-100">
          <span className="d-block d-lg-none">
            <img
              className="img-fluid img-profile thumbnail mx-auto mb-2 border border-secondary"
              src={avatar}
              width="30%"
              border-width="100px"
              alt="A smiling headshot of me"
            />
          </span>
          <h2 className="mb-0">
            {config.firstName}
            <span className="text-primary">{config.lastName}</span>
          </h2>
          <div className="subheading mb-5">
            SHE/ HER/ HERS🙆🏽‍♀️
          </div>
          <div className="intro-container">
            <div className="introduction">
              <p className="lead">
                Hi, I am Farhana from Bangladesh! I study problematic behavior in online communities, 
                particularly in the context of the Majority World (i.e., the Global South).
                <br />
                <br />I am a 3rd year PhD student in 
                <a
                  href="https://infosci.cornell.edu/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon"> Cornell Information Science</span>
                </a>{", "}
                 advised by Professor{" "}
                <a
                  href="https://www.adityavashistha.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon">Aditya Vashistha</span>
                </a>
                . I study how the content moderation infrastructures that are in place to address problematic 
                content impact users in the Majority World. I particularly focus on this region because 
                people from these communities not only comprise the largest and fastest growing userbases of 
                online platforms but also experience the worst of online harms, both as users and content moderators. 
                I use mixed-methods to bring new insights 
                about the impact and design of content moderation systems by integrating diverse values of the 
                users from the margin. Through my research, I advocate for creating online spaces that care for 
                and are responsible towards the Majority World users with whom and for whom I am working. 
                <br />
                <br />
                I completed my Bachelors and Masters in Computer Science and Engineering from 
                <a
                  href="https://cse.buet.ac.bd/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon"> BUET</span>
                </a>
                , advised by Professor{" "}
                <a
                  href="https://sites.google.com/site/abmalimalislam/home"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon">A. B. M. Alim Al Islam.</span>
                </a>{" "}
                I also worked as a lecturer of Computer Science at{" "}
                <a
                  href="https://www.bracu.ac.bd/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon">Brac University</span>
                </a>{" "}
                and{" "}
                <a
                  href="https://www.easternuni.edu.bd/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sym-icon">Eastern University.</span>
                </a>{" "}
                <br />
                <br />
                Apart from research, I am very much drawn to books, concerts, jigsaw puzzles, long walks, and 
                full moons.
                <br />
                <br />
                <a
                  href={withPrefix("/files/FSH CV.pdf")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                <span className="sym-icon"><b>Download CV</b></span>
                </a>{" "}
              </p>

              <div className="social-icons">
                {config.socialLinks.map((social) => {
                  const { icon, url } = social;
                  return (
                    <a
                      key={url}
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={icon}></i>
                    </a>
                  );
                })}
              </div>
            </div>

            <div className="news">
              <span className="recNews">
                <b>Recent News</b>
              </span>
              <ul class="fa-ul">
              <li>
                  <span class="fa-li">
                    <i class="fas fa-newspaper"></i>
                  </span>
                  <b>Apr 24</b>: Our paper on conversational agents to address harmful content in WhatsApp groups 
                  got accepted to CSCW 2024!
              </li>
              <li>
                  <span class="fa-li">
                    <i class="fas fa-award"></i>
                  </span>
                  <b>Apr 24</b>: Our paper on content moderation in WhatsApp groups won the <b>Best Student Paper Award </b> 
                  at Social Media and Society in India Symposium!
              </li>
              <li>
                  <span class="fa-li">
                    <i class="fas fa-microphone"></i>
                  </span>
                  <b>Apr 24</b>: I gave a talk in Social Computing Research Lab at University of Michigan!
              </li>
              <li>
                  <span class="fa-li">
                    <i class="fas fa-pen-square"></i>
                  </span>
                  <b>Mar 24</b>: Received 2 special recognitions for my reviews in CSCW 2024.
              </li>
              <li>
                  <span class="fa-li">
                    <i class="fas fa-handshake"></i>
                  </span>
                  <b>Feb 24</b>: This Summer I'll be interning with the Research team at Center for Democracy and Technology! 
              </li>
              <li>
                  <span class="fa-li">
                    <i class="fas fa-microphone"></i>
                  </span>
                  <b>Feb 24</b>: I gave a guest lecture in Antisocial Computing class at UC San Diego! 
              </li>
              <li>
                  <span class="fa-li">
                    <i class="fas fa-microphone"></i>
                  </span>
                  <b>Jan 24</b>: I gave a talk in HCI Graduate Seminar at UC Berkeley! 
              </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-lg-5 p-md-4 d-flex justify-content-center"
        id="publication"
      >
        <div className="w-100">
          <h2 className="mb-5">Publications</h2>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2024</h3>
              <ul className="papers">
              <li className="paper">
                  
                  <span className="sym-icon">
                  Conversational Agents to Facilitate Deliberation on Harmful Content in WhatsApp Groups. 
                  </span>
                  <br />
                  Dhruv Agarwal, <span className="authorMe">Farhana Shahid</span>, and Aditya Vashistha. 
                  To appear in{" "}
                  <span className="publishedwhere">
                    {" "}
                    CSCW 2024.
                  </span> 
                  <br/>
                </li> 
                <br/>
              </ul>
            </div>
          </div>


          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2023</h3>
              <ul className="papers">
              <li className="paper">
                  <a
                    href="https://doi.org/10.1145/3544548.3581538"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  <span className="sym-icon">
                  Decolonizing Content Moderation: Does Uniform Global 
                  Community Standard Resemble Utopian Equality or Western Power Hegemony? 
                  </span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span> and Aditya Vashistha. 
                  In{" "}
                  <span className="publishedwhere">
                    {" "}
                    CHI Conference on Human Factors in Computing Systems (CHI 2023).
                  </span> [
                  <a
                    href={withPrefix("/files/chi23-decolonial-moderation.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ][
                  <a
                    href={withPrefix("/files/chi23_decolonial_moderation.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Slides</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/Mb14Rkx8xyU"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                  <br/>
                </li> 
                <br/>
              </ul>
            </div>
          </div>


          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2022</h3>
              <ul className="papers">
              
              <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3491102.3517646"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  <span className="sym-icon">"It Matches My Worldview": Examining Perceptions and Attitudes Around Fake Videos.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Srujana Kamath, Annie Sidotam, Vivian Jiang, Alexa Batino, and Aditya Vashistha. 
                  In{" "}
                  <span className="publishedwhere">
                    {" "}
                    CHI Conference on Human Factors in Computing Systems (CHI 2022).
                  </span> [
                  <a
                    href={withPrefix("/files/chi22_fake_video.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ][
                  <a
                    href={withPrefix("/files/chi22_deepfake.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Slides</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/m5rI7HE2Rrk"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                  <br/>
                </li> 
                <br/>

                <li className="paper">
                <a
                    href="https://dl.acm.org/doi/10.1145/3512936"
                    target="_blank"
                    rel="noopener
            noreferrer"
                  >
                  <span className="sym-icon">Examining Source Effects on Perceptions of Fake News in Rural India.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Shrirang Mare, and Aditya Vashistha. In{" "}
                  <span className="publishedwhere">
                    {" "}
                    Proceedings of the ACM on Human-Computer Interaction
                  </span>
                  : Vol. 6, Issue CSCW1, Article 89. [
                  <a
                    href={withPrefix("/files/Source_Effect_CSCW.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={withPrefix("/files/source_effect_cscw22.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Slides</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/yd3o2SlvSoI"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]

                  <br/>
                </li>
              </ul>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2021</h3>
              <ul className="papers">
                <li className="paper">
                  <a
                    href={withPrefix("/files/FSH_MSc_Thesis.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Leveraging Features from EEG and Free-Hand Sketches for
                    Effective Diagnosis of Post-Traumatic Stress Disorder.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>. M.Sc. Engg.
                  Thesis, Department of Computer Science and Engineering, BUET.
                </li>
              </ul>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-3">
            <div className="resume-content">
              <h3 className="mb-0">2020</h3>
              <ul className="papers">
                <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3411835"
                    target="_blank"
                    rel="noopener
	          noreferrer"
                  >
                    <span className="sym-icon">Leveraging Free-Hand Sketches for Potential Screening of
                    PTSD.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Wasifur
                  Rahman, M. Saifur Rahman, Sharmin Akther Purabi, Ayesha
                  Seddiqa, Moin Mostakim, Farhan Feroz, Tanjir Rashid Soron,
                  Fahmida Hossain, Nabila Khan, Anika Binte Islam, Nipi Paul,
                  Ehsan Hoque, and A. B. M. Alim Al Islam. In{" "}
                  <span className="publishedwhere">
                    {" "}
                    Proceedings of the ACM on Interactive Mobile, Wearable and
                    Ubiquitous Technologies (IMWUT' 20)
                  </span>
                  : Vol. 4, No. 3, Article 94. [
                  <a
                    href={withPrefix("/files/Sketch_Camera_Ready.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={withPrefix("/files/UbiComp20_Sketch.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Slides</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/-L8GdW69AFU"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                </li>
                <br />

                <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3392875"
                    target="_blank"
                    rel="noopener
	          noreferrer"
                  >
                    <span className="sym-icon">Learning from Tweets: Opportunities and Challenges to Inform
                    Policy Making During Dengue Epidemic.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Shahinul
                  Hoque Ony, Takrim Rahman Albi, Sriram Chellappan, Aditya
                  Vashistha, and A. B. M. Alim Al Islam. In{" "}
                  <span className="publishedwhere">
                    {" "}
                    Proceedings of the ACM on Human-Computer Interaction
                  </span>
                  : Vol. 4, Issue CSCW1, Article 65. [
                  <a
                    href={withPrefix("/files/cscw_dengue_2020.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={withPrefix("/files/CSCW20_Presentation.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Slides</span>
                  </a>
                  ] [
                  <a
                    href={"https://youtu.be/Oe0fD_LwpyY"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Video</span>
                  </a>
                  ]
                </li>
                <span class="sym-icon">
                  <i class="fas fa-award"></i>
                  <b> CSCW Honorable Mention Award</b>
                </span>
              </ul>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between">
            <div className="resume-content">
              <h3 className="mb-0">2019</h3>
              <ul className="papers">
                <li className="paper">
                  <a
                    href="https://dl.acm.org/doi/10.1145/3351259"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Two Tell-tale Perspectives of PTSD: Neurobiological
                    Abnormalities and Bayesian Regulatory Network of the
                    Underlying Disorder in a Refugee Context.</span>
                  </a>
                  <br />
                  <span className="authorMe">Farhana Shahid</span>, Wasifur
                  Rahman, Anika Binte Islam, Nipi Paul, Nabila Khan, Mohammad
                  Saifur Rahman, Md Munirul Haque, and A. B. M. Alim Al Islam.
                  In{" "}
                  <span className="publishedwhere">
                    Proceedings of the ACM on Interactive Mobile, Wearable and
                    Ubiquitous Technologies (IMWUT' 19)
                  </span>
                  : Vol. 3, No. 3, Article 101. [
                  <a
                    href={withPrefix("/files/FSH_IMWUT19.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">PDF</span>
                  </a>
                  ] [
                  <a
                    href={withPrefix("/files/UbiComp19_PTSD.pdf")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="sym-icon">Slides</span>
                  </a>
                  ]
                </li>
                <span class="sym-icon">
                  <i class="fas fa-award"></i>
                  <b> IMWUT Distinguished Paper Award</b>
                </span>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-lg-5 p-md-4 d-flex align-items-center"
        id="research"
      >
        <div className="w-100">
          <h2 className="mb-5">Research</h2>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">

            <div className="resume-content">

              <h4 className="mb-3">Rethinking Content Moderation Infrastructures</h4>
              <div className="paper-container">
                <div className="paper-body">
                  <p className="paper">
                    The existing content moderation infrastructures of Silicon Valley based social media 
                    corporations are mostly rooted in the Western values. They barely address the unique needs 
                    and circumstances of the users from the Majority World, who comprise the majority of the 
                    userbase of these platforms. This creates power imbalances as these Western corporations control 
                    the narrative of appropriate speeches online while exploiting the cheap workforce from the 
                    Global South to distill harmful content on their platforms. Due to inappropriate removal of 
                    culturally relevant content and lack of moderation tools to curb harmful content 
                    in non-Western languages, users from the Majority World often suffer more than their 
                    Western counterparts. Towards this end, my work aims to unravel the hidden hierarchies
                    in content moderation infrastructures and promotes reimagining content 
                    moderation systems from a critical perspective. 
                    <br />
                    Publications:{" "}
                    <a
                      href={withPrefix("/files/chi23-decolonial-moderation.pdf")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="sym-icon">CHI 2023</span>
                    </a>
                  </p>
                </div>
                <div className="paper-image">
                  <img
                    className="img-fluid"
                    src={violation}
                    alt="Jun 25, 2021. You couldn't post or comment for 24 hours. Why was your account restricted? 
                    Multiple posts from the last year didn't follow our standards. You shared this on your profile. Closed. Jun 25, 2021. 
                    Did anyone stop you from sharing your opinion? What kind of behavior is this to curse someone as Malaun? 
                    Labelled as Hate."
                  />
                  <p className="img-caption">
                    User got penalized for speaking up against religious hate speech as they quoted the slang used against them.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">

            <div className="resume-content">

              <h4 className="mb-3">Misinformation in the Majority World</h4>
              <div className="paper-container">
                <div className="paper-body">
                  <p className="paper">
                    As the growth and popularity of many major social media platforms have saturated in the 
                    Global North, platforms are now targeting users from the Majority World. Many of these first 
                    generation Internet users are often low-literate, lack technological know-hows, and are 
                    exposed to global platforms that do not incorporate local values and sensibilities 
                    in their design. All these make them more susceptible to the harms of online misinformation and fake 
                    news. However, there is little focus on how users from the Majority World perceive and interact 
                    with different modalities (i.e., text, image, video, or audio) of misinformation. In this regard, we study 
                    what factors influence users' perceptions of misinformation and 
                    explore how to incorporate responsible design practices on social media to better help these 
                    users deal with online misinformation and fake news.

                    <br />
                    Publications:{" "}
                    <a
                      href={withPrefix("/files/Source_Effect_CSCW.pdf")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="sym-icon">CSCW 2022</span>
                    </a>
                    ,
                    <a
                      href={withPrefix("/files/chi22_fake_video.pdf")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <span className="sym-icon">CHI 2022</span>
                    </a>
                  </p>
                </div>
                <div className="paper-image">
                  <img
                    className="img-fluid"
                    src={srcEffect}
                    alt="A simulated Facebook post from actor Priyanka Chopra saying Delhi Chief Minister Arvvind Kejriwal 
                    has said that the number of coronavirus-related deaths has declined."
                  />
                  <p className="img-caption">
                    Controlled experiment to see how various sources (e.g., news media) affect users' trust in online news.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">

            <div className="resume-content">

              <h4 className="mb-3">PTSD within Low-Resource Communities</h4>
              <div className="paper-container">
                <div className="paper-body">
                  <p className="paper">
                    Critical lack of trained mental health professionals,
                    communication and cultural barriers, social stigma around
                    mental health in low-rosurce communities expose the
                    traumatized individuals to greater health risks. Traditional
                    diagnostic tools of PTSD often suffer from under-utilization
                    due to various issues associated with human-human
                    interactions while applying them within resource-scarce
                    populations. In this regard, we aim to explore alternative
                    methods to potentially screen for PTSD using various
                    low-cost, off-the-shelf tools, e.g., portable EEG headsets
                    and free-hand sketches using simple pencil and paper.
                    Findings from our field work involving refugees and
                    slum-dwellers enable us to identify scopes for improvement
                    in screening the potential cases of PTSD within low-rosurce
                    communities.
                    <br />
                    Publications:{" "}
                    <a
                      href={withPrefix("/files/FSH_IMWUT19.pdf")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="sym-icon">IMWUT 2019</span>
                    </a>
                    ,
                    <a
                      href={withPrefix("/files/Sketch_Camera_Ready.pdf")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <span className="sym-icon">IMWUT 2020</span>
                    </a>
                  </p>
                </div>
                <div className="paper-image">
                  <img
                    className="img-fluid"
                    src={camp}
                    alt="Some female Rohingya refugees are waiting in a room for interview in the camp area"
                  />
                  <p className="img-caption">
                    Kutupalong Rohingya refugee camp, Cox's Bazar, Bangladesh
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-lg-5 p-md-4 d-flex align-items-center"
        id="teaching"
      >
        <div className="w-100">
          <h2 className="mb-5">Teaching</h2>

          <h3 className="mb-3">Appointments</h3>

          
          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="resume-content">
              <h4 className="mb-0">Graduate Teaching Assistant</h4>
              <div className="subheading mb-1">
                Department of Information Science, Cornell University
              </div>
            </div>
            <div className="resume-date text-md-right">
              <span className="text-primary">Aug 2021 - Present</span>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="resume-content">
              <h4 className="mb-0">Lecturer</h4>
              <div className="subheading mb-1">
                Department of Computer Science and Engineering, Brac University
              </div>
            </div>
            <div className="resume-date text-md-right">
              <span className="text-primary">May 2018 - May 2021</span>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="resume-content">
              <h4 className="mb-0">Lecturer</h4>
              <div className="subheading mb-1">
                Department of Computer Science and Engineering, Eastern
                University
              </div>
            </div>
            <div className="resume-date text-md-right">
              <span className="text-primary">September 2017 - April 2018</span>
            </div>
          </div>

          <h3 className="mb-3">Courses Taught</h3>

          <ul className="fa-ul mb-0">
        
            <li>
              <i className="fa-li fa fa-check"></i>
              Computer Graphics (Spring 2021, Fall 2020, Summer 2020, Spring
              2020, Fall 2019, Summer 2019, Spring 2019, Spring 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Pattern Recognition (Fall 2020, Summer 2020)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Artificial Intelligence (Spring 2020, Fall 2019)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Object Oriented Programming (Fall 2019, Summer 2019, Spring 2019,
              Fall 2018, Summer 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Digital Logic Design (Spring 2020, Summer 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Algorithms (Summer 2019, Fall 2019, Summer 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Data Structures (Summer 2019, Summer 2018)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Operating Systems (Spring 2018, Fall 2017)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Mathematical Analysis for Computer Science (Fall 2017)
            </li>
          </ul>
          <br />
          <h3 className="mb-3">Courses Assisted</h3>
          <ul className="fa-ul mb-0">
          <li>
              <i className="fa-li fa fa-check"></i>
              Technology for Underserved Communities (Spring 2023)
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Computing and Global Development (Spring 2024, Fall 2022, Fall 2021)
            </li>
            </ul>

            <br/>
        </div>
      </section>
    </div>
  </Layout>
);

export default Named;
